import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

export type EquityGraphData = {
  date: string;
  equity: number;
  equityChange: number;
  isCompanyIncorporation?: boolean;
  name: string;
  participation: number;
  parValue?: string;
  postMoneyValuation: number;
  sharesValue: number;
  totalConsideredPay?: number;
  totalIssuedShares?: number;
  totalRaised: number;
};

export const useEquityGraphData = ({
  companyId,
  stakeholderId,
}: {
  companyId: string;
  stakeholderId: string;
}) => {
  const queryClient = useQueryClient();

  const { data: graphData, isLoading } = useAppQuery<EquityGraphData[]>({
    queryKey: [QueryKey.GET_EQUITY_GRAPH_DATA, companyId, stakeholderId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', stakeholderId, 'equity-graph-data'],
      }),
    enabled: !!companyId && !!stakeholderId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_EQUITY_GRAPH_DATA] });
  }, [queryClient]);

  return {
    invalidateQuery,
    graphData,
    isLoading,
  };
};
